module.exports = __webpack_public_path__ + "static/media/icon-calendar.3ce3e87e.svg";